export const mutations = {
    setUser(state, payload) {
        localStorage.setItem("UserInfo", JSON.stringify(payload))
        state.user = payload;
    },
    setError(state, payload) {
        state.error = payload
    },
    setLoading(state, payload) {
        state.loading = payload
    },
    setAccessToken(state, payload) {
        state.accessToken = payload
        localStorage.setItem("AccessToken", payload)
        return state.access_token
    }
}